import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line\"><path d=\"M811.693-.001l184.478 184.478-811.69 811.69L.002 811.69 811.693 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol